// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    gs: This.GoalSetting;
    viewMode: This.GoalSettingViewMode;
    columnVisibility: This.GoalSettingGoalColumnVisibility;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-GoalSettingViewInclude',
    templateUrl: './GoalSettingViewInclude.html',
    styleUrls: ['./GoalSettingViewInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalSettingViewInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.GoalSettingViewInclude';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    input_gs = input(undefined, { alias: 'gs' });
    var_gs = proxySignal<This.GoalSetting>(undefined as any);
    input_viewMode = input(undefined, { alias: 'viewMode' });
    var_viewMode = proxySignal<This.GoalSettingViewMode>(undefined as any);
    var_columnVisibility = proxySignal<This.GoalSettingGoalColumnVisibility>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get gs() { return component.var_gs() },
                set gs(value: This.GoalSetting) { component.var_gs.set(value) },
                get viewMode() { return component.var_viewMode() },
                set viewMode(value: This.GoalSettingViewMode) { component.var_viewMode.set(value) },
                get columnVisibility() { return component.var_columnVisibility() },
                set columnVisibility(value: This.GoalSettingGoalColumnVisibility) { component.var_columnVisibility.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            gs: this.screen.gs,
            viewMode: this.screen.viewMode
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_gs = this.dialogData?.data?.gs ?? this.input_gs() ?? (undefined)
            if (new_gs !== undefined) this.screen.gs = new_gs


            const new_viewMode = this.dialogData?.data?.viewMode ?? this.input_viewMode() ?? (undefined)
            if (new_viewMode !== undefined) this.screen.viewMode = new_viewMode

            if (!isVariablesInitialized) this.screen.columnVisibility = (undefined)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_ButtonBlock_83_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.gs.status.id = (await This.GoalSetting.save(screen.gs, 'submit')).newStatusId
                    Sys.App.showNotification('success', 'Successfully submitted')
                    This.GoalSettingUtil.confetti()
                    form.markAsPristine()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_84_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    await This.GoalSetting.save(screen.gs, 'save')
                    Sys.App.showNotification('success', 'Successfully saved')
                    form.markAsPristine()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_118_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.gs.status.id = (await This.GoalSetting.save(screen.gs, 'submit')).newStatusId
                    Sys.App.showNotification('success', 'Successfully submitted')
                    This.GoalSettingUtil.confetti()
                    form.markAsPristine()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_119_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    await This.GoalSetting.save(screen.gs, 'save')
                    Sys.App.showNotification('success', 'Successfully saved')
                    form.markAsPristine()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_99_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    const result = await This.GoalSetting.save(screen.gs, 'submit')
                    screen.gs.status.id = result.newStatusId
                    Sys.App.showNotification('success', 'Successfully acknowledged, going to goal setting', 5000)
                    Sys.Screen.navigateToScreen(This.$Screens.GoalSettingView, { id: result.nextGsId })
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _ScopeBlock_var_isSomeRejectionComment_108($scope: any): boolean {
        let { app, screen, $pathSegments, $disabled, form }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, form: Sys.Types.Form } = $scope ?? {}

        const memoizedFn = memoize($scope, () => {
            return (
                [...screen.gs.performanceGoals, ...screen.gs.developmentGoals].some(g => g.rejectionComment?.length > 7)
            )
        })
        return memoizedFn()
    }

    async handler_ButtonBlock_94_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, isSomeRejectionComment, $disabled }: { form: Sys.Types.Form, isSomeRejectionComment: boolean, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.gs.status.id = (await This.GoalSetting.save(screen.gs, 'approve')).newStatusId
                    Sys.App.showNotification('success', 'Successfully approved')
                    This.GoalSettingUtil.confetti()
                    form.markAsPristine()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_102_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, isSomeRejectionComment, $disabled }: { form: Sys.Types.Form, isSomeRejectionComment: boolean, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.gs.status.id = (await This.GoalSetting.save(screen.gs, 'reject')).newStatusId
                    Sys.App.showNotification('success', 'Successfully rejected')
                    form.markAsPristine()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_106_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (!confirm('Are you sure you want to proceed? The employee will then see your assessment')) return

                    screen.gs.status.id = (await This.GoalSetting.save(screen.gs, 'submit')).newStatusId
                    Sys.App.showNotification('success', 'Successfully completed assessment')
                    This.GoalSettingUtil.confetti()
                    form.markAsPristine()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_107_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    await This.GoalSetting.save(screen.gs, 'save')
                    Sys.App.showNotification('success', 'Successfully saved')
                    form.markAsPristine()
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.columnVisibility = screen.gs.getColumnVisibility(screen.viewMode)
        }
    }
}
